<script>
/* eslint-disable */

import TabbedChildMixin from './TabbedChildMixin.js'

export default {
  name: 'MTabItem',
  mixins: [TabbedChildMixin('tab')],
  props: {
    disabled: Boolean
  },
  data() {
    return {
      elementClass: 'tab-item',
      elementRole: 'tabpanel'
    }
  }
}
</script>
